import styled from 'styled-components';
import { FADE, t } from 'theme';

/**
 * Night used to be a grey gradient fading to transparent behind white text, which left the
 * lower half of the header unreadable and stopped dead at the header's edge. Night is now a
 * page-level theme (see Theme.style.js); the header carries no chrome of its own and lets its
 * colours come from the palette.
 */
const Header = styled.div`
  display: grid;
  grid-template-columns: auto repeat(1, 1fr);
  height: 30px;
  align-items: center;
  justify-items: end;
  min-width: 850px;
  padding-bottom: 10px;
  color: ${t('fg')};
  transition: color ${FADE};

  /* Above the closing vignette (Page.style.js, z-index 9), and this is the point of the effect
     rather than an exception to it. The dark comes up around the header and the header does not
     go with it: the world narrows to the one number that is killing the player, which is both the
     right image and the only way the readout stays legible at the moment it matters most. The
     header paints no background, so nothing punches a rectangle through the dark — only the text
     stands out of it. */
  position: relative;
  z-index: 10;
`;

export default Header;
